import { Injectable } from '@angular/core';
import { dispatch } from '@angular-redux/store';
import { AnyAction } from 'redux';

@Injectable()
export class LoggedActionService {

    static SET_LOGGED_USER_CURRENT = 'SET_LOGGED_USER_CURRENT';
    static REFRESH_TOKEN = 'REFRESH_TOKEN';

    constructor() { }

    @dispatch()
    setLoggedUserCurrent = ( data ): AnyAction => ({ type: LoggedActionService.SET_LOGGED_USER_CURRENT, payload: data })

    @dispatch()
    refreshToken = ( data ): AnyAction => ({ type: LoggedActionService.REFRESH_TOKEN, payload: data })

}
